import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  DEFAULT_TERMS,
  quillFormats,
  quillModules,
} from "../../helper/quotation";

const TermsAndTaxSummary = ({
  quotationData,
  handleChange,
  taxSummary,
  taxType,
}) => {
  return (
    <>
      <div className="row mt-4">
        <div className="col-12 col-md-7 col-xl-8">
          <div
            className="card shadow-sm h-100"
            style={{ border: "1px solid #e0e0e0" }}
          >
            <div
              className="card-header"
              style={{
                backgroundColor: "rgba(255, 105, 35, 0.1)",
                border: "1px solid var(--primary-clr)",
                color: "var(--primary-clr)",
              }}
            >
              <h6
                className="mb-0 fw-semibold"
                style={{ color: "var(--primary-clr)", fontSize: "15px" }}
              >
                <i
                  className="fa fa-file-text me-2"
                  style={{ color: "var(--primary-clr)" }}
                ></i>
                Terms and Conditions
              </h6>
            </div>

            <div
              className="card-body p-0 terms-editor-wrapper"
              style={{ height: "", overflow: "hidden" }}
            >
              <ReactQuill
                theme="snow"
                value={
                  quotationData.terms_and_condition?.trim()
                    ? quotationData.terms_and_condition
                    : DEFAULT_TERMS
                }
                onChange={(value) =>
                  handleChange(null, "terms_and_condition", value)
                }
                modules={quillModules}
                formats={quillFormats}
                style={{ height: "37  0px" }}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-5 col-xl-4">
          <div
            className="card shadow-sm h-100"
            style={{ border: "1px solid #e0e0e0" }}
          >
            <div
              className="card-header"
              style={{
                background:
                  "linear-gradient(135deg, var(--primary-clr) 0%, #ff8c42 100%)",
                color: "white",
                padding: "14px 20px",
                borderRadius: "0.25rem 0.25rem 0 0",
              }}
            >
              <h6
                className="mb-0 fw-semibold"
                style={{
                  fontSize: "15px",
                  color: "#fff",
                  letterSpacing: "0.3px",
                }}
              >
                <i className="fa fa-calculator me-2"></i>
                Tax Summary
              </h6>
            </div>
            <div className="card-body" style={{ padding: "20px" }}>
              <div
                className="mb-3 pb-3"
                style={{ borderBottom: "1px solid #e9ecef" }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span style={{ color: "#6c757d", fontSize: "14px" }}>
                    Subtotal
                  </span>
                  <span
                    className="fw-semibold"
                    style={{ color: "#2c3e50", fontSize: "15px" }}
                  >
                    ₹ {taxSummary.subtotal.toFixed(2)}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span style={{ color: "#6c757d", fontSize: "14px" }}>
                    Total Quantity
                  </span>
                  <span
                    className="fw-semibold"
                    style={{ color: "#2c3e50", fontSize: "15px" }}
                  >
                    {quotationData.total_quantity.toFixed(2)}
                  </span>
                </div>
              </div>

              <div
                className="mb-3 pb-3"
                style={{ borderBottom: "1px solid #e9ecef" }}
              >
                <div className="mb-2">
                  <span
                    className="fw-semibold"
                    style={{ color: "var(--primary-clr)", fontSize: "14px" }}
                  >
                    Tax Breakdown (18%)
                  </span>
                </div>
                {taxType === "cgst_sgst" ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2 ms-1">
                      <span style={{ color: "#6c757d", fontSize: "13px" }}>
                        CGST @ 9%
                      </span>
                      <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                        ₹ {taxSummary.cgst.toFixed(2)}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center ms-1">
                      <span style={{ color: "#6c757d", fontSize: "13px" }}>
                        SGST @ 9%
                      </span>
                      <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                        ₹ {taxSummary.sgst.toFixed(2)}
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="d-flex justify-content-between align-items-center ms-1">
                    <span style={{ color: "#6c757d", fontSize: "13px" }}>
                      IGST @ 18%
                    </span>
                    <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                      ₹ {taxSummary.igst.toFixed(2)}
                    </span>
                  </div>
                )}
              </div>

              <div
                className="mb-3 pb-3"
                style={{ borderBottom: "1px solid #e9ecef" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span style={{ color: "#6c757d", fontSize: "14px" }}>
                    Round Off
                  </span>
                  <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                    {taxSummary.roundOff >= 0 ? "+" : ""} ₹{" "}
                    {taxSummary.roundOff.toFixed(2)}
                  </span>
                </div>
              </div>

              <div
                className="p-3 rounded"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(255, 105, 35, 0.1) 0%, rgba(255, 140, 66, 0.1) 100%)",
                  border: "1px solid var(--primary-clr)",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span
                    className="fw-bold"
                    style={{ color: "var(--primary-clr)", fontSize: "16px" }}
                  >
                    Total Amount
                  </span>
                  <span
                    className="fw-bold"
                    style={{ color: "var(--primary-clr)", fontSize: "18px" }}
                  >
                    ₹ {taxSummary.total.toFixed(2)}
                  </span>
                </div>
              </div>

              <div
                className="mt-3 p-2 rounded text-center"
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px dashed var(--primary-clr)",
                }}
              >
                <small
                  style={{
                    color: "var(--primary-clr)",
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  <i className="fa fa-info-circle me-1"></i>
                  Tax Type: {taxType === "cgst_sgst" ? "CGST + SGST" : "IGST"}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndTaxSummary;
